//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../Features/Features.Subdivision.SelectCageObjectData.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[1,"Transformer",0,"GeometricUtilities.TransformerData",0]],[[["moveData"],"PrepareToMove",{},1,0],[["moveToPoint","isSnapGesture"],"Move",{},2,1],[["moveToPoint","point","isSnapGesture"],"Move1",{},3,0],[[],"EndMove",{},0,0],[["step"],"StepMove",{},1,0],[[],"ResetTransformerToCentroidOfSelection",{},0,0],[["selectionData"],"SetTransformerToObject",{},1,0],[["location"],"ResetTransformerToLocation",{},1,0]],[]];
SPLM.Features.Subdivision.CageManipulatorData = class extends SPLM.Features.Subdivision.SelectCageObjectData{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Subdivision.CageManipulatorData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.CageManipulatorData.ObjectMoveData = class{
    constructor(draggedObject,beginDragCursorPosition,beginDragObjectPosition,view,micropositioningScale,viewDirection){
        this.draggedObject=draggedObject;this.beginDragCursorPosition=beginDragCursorPosition;this.beginDragObjectPosition=beginDragObjectPosition;this.view=view;this.micropositioningScale=micropositioningScale;this.viewDirection=viewDirection;}
    get Draggedobject(){return this.draggedObject}
    set Draggedobject(val){this.draggedObject = val}
    get Begindragcursorposition(){if(this.beginDragCursorPosition === undefined) this.beginDragCursorPosition = new SPLM.Point3d(); return this.beginDragCursorPosition}
    set Begindragcursorposition(val){this.beginDragCursorPosition = val}
    get Begindragobjectposition(){if(this.beginDragObjectPosition === undefined) this.beginDragObjectPosition = new SPLM.Point3d(); return this.beginDragObjectPosition}
    set Begindragobjectposition(val){this.beginDragObjectPosition = val}
    get View(){return this.view}
    set View(val){this.view = val}
    get Micropositioningscale(){return this.micropositioningScale}
    set Micropositioningscale(val){this.micropositioningScale = val}
    get Viewdirection(){if(this.viewDirection === undefined) this.viewDirection = new SPLM.Vector3d(); return this.viewDirection}
    set Viewdirection(val){this.viewDirection = val}
};

SPLM.Features.Subdivision.CageManipulatorData.ObjectSelectionData = class{
    constructor(selectedObject,selectionPosition,viewDirection,isSnappedPosition){
        this.selectedObject=selectedObject;this.selectionPosition=selectionPosition;this.viewDirection=viewDirection;this.isSnappedPosition=isSnappedPosition;}
    get Selectedobject(){return this.selectedObject}
    set Selectedobject(val){this.selectedObject = val}
    get Selectionposition(){if(this.selectionPosition === undefined) this.selectionPosition = new SPLM.Point3d(); return this.selectionPosition}
    set Selectionposition(val){this.selectionPosition = val}
    get Viewdirection(){if(this.viewDirection === undefined) this.viewDirection = new SPLM.Vector3d(); return this.viewDirection}
    set Viewdirection(val){this.viewDirection = val}
    get Issnappedposition(){return this.isSnappedPosition}
    set Issnappedposition(val){this.isSnappedPosition = val}
};

export default SPLM;